module.exports = __webpack_public_path__ + "static/media/LiveEventProfile.74d76090.png";